import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { GuideModal } from './GuideModal';
import { Sparkle } from './Sparkle';
export function Hero() {
  const [guideOpen, setGuideOpen] = useState(false);
  return <section id="start" className="relative w-full px-4 pb-0 pt-10 sm:px-6 sm:pt-12" data-id="element-285" data-mp="9igvb8esxojn">
      <div className="mx-auto grid max-w-[1300px] items-end gap-8 lg:grid-cols-[2.6fr_1fr] lg:gap-2 xl:grid-cols-[1.75fr_1fr] xl:gap-4" data-id="element-286" data-mp="4jm69oq8r3r3">
        <div className="flex h-full flex-col justify-center pb-0 pt-2 text-center sm:pt-2 lg:pb-16 lg:pt-0 lg:pl-0 xl:pl-12 xl:text-left" data-id="element-287" data-mp="x9urjpg2q49w">
          <div className="relative block w-full self-center lg:w-[136%] lg:self-start xl:w-full" data-id="element-288" data-mp="s9q8psrp0xgi">
            <Sparkle className="animate-sparkle -left-2 -top-3 h-5 w-5 sm:h-6 sm:w-6 md:hidden lg:block lg:-left-6 lg:-top-6 lg:h-8 lg:w-8" data-id="element-289" data-mp="nboo33emcq2x" />
            <Sparkle className="animate-sparkle-delayed -bottom-2 -right-4 h-4 w-4 sm:h-5 sm:w-5 md:bottom-1 md:left-[39%] md:right-auto lg:-bottom-3 lg:left-auto lg:-right-7" data-id="element-290" data-mp="382fhvvzgliim" />
            <motion.h1 initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            ease: 'easeOut'
          }} className="font-display text-gold-3d mt-0 text-2xl font-extrabold uppercase leading-[1.15] sm:text-3xl md:text-justify lg:text-4xl lg:text-justify xl:text-justify" data-id="element-291" data-mp="3j6fw9kdl53b7">
              Verdiene 10.000€+ monatlich als Closerin, selbst wenn du noch nie verkauft hast –
              ohne Social Media Reichweite &amp; ohne eigenes Produkt
            </motion.h1>
          </div>

          <p className="mx-auto mt-5 max-w-full text-[15px] leading-relaxed text-white sm:text-base lg:mx-0 lg:pr-10 lg:text-left" data-id="element-292" data-mp="2qlenwia5hgd4">
            <span className="block font-semibold uppercase tracking-wide" data-id="element-293" data-mp="2vglk7513bis0">
              Raus aus dem 9-to-5-Hamsterrad.
            </span>
            <span className="mt-3 block" data-id="element-294" data-mp="2ll0fv08ju6f3">
              In nur 8 Wochen zeigen wir dir, wie du als Premium-Closerin ortsunabhängig arbeiten
              und dir mit deinen Sales-Skills ein attraktives Einkommen aufbauen kannst.
            </span>
            <span className="mt-3 block" data-id="element-295" data-mp="n98djnya55nw">
              Lerne, authentisch und ohne Druck zu verkaufen, hochpreisige Angebote sicher
              abzuschließen und dabei 500–1.500€ Provision pro Abschluss zu verdienen – auch ohne
              Vorkenntnisse.
            </span>
          </p>

          <div className="relative mx-auto mt-8 self-center lg:mx-0 lg:self-start" data-id="element-296" data-mp="1ayt9d7fj7xel">
            <Sparkle className="animate-sparkle-fast -bottom-3 -right-4 h-6 w-6" data-id="element-297" data-mp="162c8rdr5bqkm" />
            <button type="button" onClick={() => setGuideOpen(true)} className="btn-gold-shiny inline-flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold" data-id="element-298" data-mp="111esx7tlz8ma">
              Guide kostenlos sichern
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-299" data-mp="3hqu1s86is404" />
            </button>
          </div>
        </div>

        <div className="relative flex items-end justify-center self-end lg:justify-end" data-id="element-300" data-mp="1xacfx49qzltr">
          <motion.img initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15,
          ease: 'easeOut'
        }} src="https://cdn.magicpatterns.com/uploads/nFNmmy8cS1ztQEVWsSgFT1/image.png" alt="Tina Xla mit Laptop und Hot Sales Girls Logo" className="block w-[110%] max-w-3xl object-contain md:w-full md:max-w-2xl lg:w-[152%] lg:max-w-4xl xl:w-[115%] xl:max-w-5xl" data-id="element-301" data-mp="21a4sds29ic4e" />

          <ul className="pointer-events-none absolute inset-0" data-id="element-302" data-mp="2p0qpioaqabzm">
            <motion.li initial={{
            opacity: 0,
            x: -16
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: 0.35,
            ease: 'easeOut'
          }} className="absolute -left-[2%] top-[46%] rounded-full border border-hot-600 bg-hot-600/15 px-3 py-1 text-[10px] font-semibold tracking-wide text-white shadow-lg shadow-hot-600/30 backdrop-blur-sm sm:-left-[4%] sm:text-xs md:left-[10%] lg:-left-[54%] lg:top-[42%] xl:-left-[10%]" data-id="element-303" data-mp="2oye7yc8vu3n3">
              ✓ 100% Ortsunabhängig
            </motion.li>
            <motion.li initial={{
            opacity: 0,
            x: 16
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: 0.45,
            ease: 'easeOut'
          }} className="absolute right-[2%] top-[62%] rounded-full border border-hot-600 bg-hot-600/15 px-3 py-1 text-[10px] font-semibold tracking-wide text-white shadow-lg shadow-hot-600/30 backdrop-blur-sm sm:right-[16%] sm:text-xs lg:-right-[2%] lg:top-[58%] xl:right-[10%]" data-id="element-304" data-mp="e8imhpn92na6">
              ✓ Freie Zeiteinteilung
            </motion.li>
            <motion.li initial={{
            opacity: 0,
            x: -16
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: 0.55,
            ease: 'easeOut'
          }} className="absolute bottom-[10%] -left-[3%] rounded-full border border-hot-600 bg-hot-600/15 px-3 py-1 text-[10px] font-semibold tracking-wide text-white shadow-lg shadow-hot-600/30 backdrop-blur-sm sm:left-0 sm:text-xs md:left-[10%] lg:-left-[54%] lg:bottom-[12%] xl:-left-[10%]" data-id="element-305" data-mp="3mnag92r7dnto">
              ✓ Ohne Vorkenntnisse
            </motion.li>
          </ul>
        </div>
      </div>

      <GuideModal open={guideOpen} onClose={() => setGuideOpen(false)} data-id="element-306" data-mp="14hhrg87cfbs7" />
    </section>;
}